const types = {
  LOGIN: "LOGIN",
  SIDEBAR_IS_OPEN: "SIDEBAR_IS_OPEN",
  GLOBAL_STATES: "GLOBAL_STATES",

  //order
  ADD_STORE: "ADD_STORE",
  ADD_FOOD: "ADD_FOOD",
  ADD_ITEM: "ADD_ITEM",
  ADD_DISCOUNT: "ADD_DISCOUNT",
  REMOVE_DISCOUNT: "REMOVE_DISCOUNT",
  INFO_ORDER: "INFO_ORDER",

  OPEN_POPUP: "OPEN_POPUP",
  CLOSE_POPUP: "CLOSE_POPUP",

  ThEME_SWITCHER: "ThEME_SWITCHER",

  USER_INFO: "USER_INFO",
  REMOVE_USER_INFO: "REMOVE_USER_INFO",

  BANK_INFO: "BANK_INFO",

  // SearchBar
  SEARCH_BAR: "SEARCH_BAR",

  // Filter on Left menu (pages)
  FILTER_ON_LEFT_MENU: "FILTER_ON_LEFT_MENU",

  // Art Order
  ART_ORDER: "ART_ORDER",

  //Select Bar
  SELECT_BAR: "SELECT_BAR",

  //Data User
  GET_DATA_USER: "GET_DATA_USER",

  //Category market
  GET_CATEGORY_MARKET: "GET_CATEGORY_MARKET",

  //category term
  GET_CATEGORY_TERM: "GET_CATEGORY_TERM",

  //type login sns
  TYPE_LOGIN_SNS: "TYPE_LOGIN_SNS",

  //shinhan
  GET_DATA_SHINHAN: "GET_DATA_SHINHAN",
};

export default types;
